import { render } from "./LangIcons.vue?vue&type=template&id=455623c5"
import script from "./LangIcons.vue?vue&type=script&lang=js"
export * from "./LangIcons.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__